import { CommonModule, Location } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { TranslationModule } from '@miq/utils';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'miq-error-page-st',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  imports: [CommonModule, MatIconModule, RouterModule, TranslationModule],
})
export class ErrorPageStandaloneComponent {
  public appName = environment.appName;
  public errorCode = 500;
  public message: string;

  constructor(
    public location: Location,
    public translationService: L10nTranslationService
  ) {
    this.message = this.translationService.translate('shared.somethingWentWrong');
  }
}
